<template>
  <v-col cols="4">
    <v-autocomplete
        v-model="selectedRecruit"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        :clearable="true"
        hide-no-data
        hide-selected
        item-text="recruitInfo"
        placeholder="Search Recruits"
        return-object
        solo-inverted
    >
    </v-autocomplete>
    <ErrorDialog ref="errorDialog"/>
  </v-col>
</template>

<script>
import ErrorDialog from "./ErrorDialog";
import _debounce from 'lodash/debounce';
export default {
  name: "SearchRecruits",
  props: {
    username: {
      type: String,
      required: true,
    },
  },
  components: {ErrorDialog},
  data: () => ({
    recruits: [],
    pagination: {},
    selectedRecruit: null,
    search: '',
    isLoading: false,

    debounceGetRecruits: _debounce(function(){
      this.searchRecruits();
    }, 500)
  }),
  methods: {
    searchRecruits: function () {
      if(this.search) {
        this.isLoading = true;
        this.$axios.get(`/recruits`, {
          params: {
            search: this.search,
            username: this.username
          }
        })
            .then(({data}) => {
              this.pagination = data;
              this.recruits = data.data;
            })
            .catch(({response}) => {
              this.$refs.errorDialog.showError({
                errorMessage: `Failed to search for ${this.search}. Please try again with different text.`,
                forDevelopers: response
              })
            })
            .finally(() => {
              this.isLoading = false;
            });
      }
    },
  },
  computed: {
    // Returns the member info in the format the search autocomplete needs.
    items () {
      return this.recruits.map(recruit => {
        const recruitInfo = `${recruit.first_name} ${recruit.last_name}, ${recruit.username}`;
        return Object.assign({}, recruit, { recruitInfo })
      })
    },
  },
  watch: {
    search(search) {
      this.search = search;
      this.debounceGetRecruits();
    },
    selectedRecruit(selectedRecruit) {
      if (!selectedRecruit) {
        return
      }
      this.search = '';

      // Else emit an event that the recruit was selected and pass the selected recruit to the register callback.
      this.$emit('recruitSelected', selectedRecruit);
    }
  },
}
</script>

<style scoped>

</style>